import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import compose from "recompose/compose";
import { translate, WithPermission } from "admin-on-rest";
import { List, ListItem, makeSelectable } from "material-ui/List";
import { styles } from "./styles";
import {
  CategoryIcon,
  CollectionIcon,
  MarketerIcon,
  PageIcon,
  ProductIcon,
  TextIcon,
  TransferIcon,
  TicketIcon,
  SimIcon,
  ActivationIcon,
  PaymentIcon,
  AgencyIcon
} from "./icon";

// TransferIcon,
let SelectableList = makeSelectable(List);

const orderItems = [
  {
    id: 2,
    label: "resources.list",
    name: "orders",
    icon: <ProductIcon />
  },
  {
    id: 3,
    label: "resources.reports.sales.name",
    name: "reports/sales",
    icon: <TextIcon title="Sr" />
  }
];

const productItems = [
  {
    id: 5,
    label: "resources.list",
    name: "products",
    icon: <ProductIcon />
  },
  {
    id: 6,
    label: "resources.categories.title",
    name: "categories",
    icon: <CategoryIcon />
  },
  {
    id: 7,
    label: "resources.collections.title",
    name: "collections",
    icon: <CollectionIcon />
  },
  {
    id: 105,
    label: "resources.tickets.title",
    name: "ticket",
    icon: <TicketIcon />
  }
];

const merchantProductItems = [
  {
    id: 5,
    label: "resources.list",
    name: "products",
    icon: <ProductIcon />
  }
];

const customerItems = [
  {
    id: 9,
    label: "resources.list",
    name: "customers",
    icon: <MarketerIcon />
  }
];
const contentItems = [
  {
    id: 12,
    label: "resources.pages.title",
    name: "pages",
    link: "/contents",
    icon: <PageIcon />
  }
];
const accountItems = [
  {
    id: 14,
    label: "resources.list",
    name: "accounts",
    icon: <MarketerIcon />
  },
  {
    id: 16,
    label: "resources.users.title",
    name: "users",
    icon: <MarketerIcon />
  },
  {
    id: 23,
    label: "resources.agency.title",
    name: "agency",
    icon: <AgencyIcon />
  }
];

const marketerItems = [
  {
    id: 19,
    label: "resources.list",
    name: "marketers",
    icon: <MarketerIcon />
  },
  {
    id: 20,
    label: "resources.marketers.transfers.title",
    name: "transfers",
    icon: <TransferIcon />
  },
  {
    id: 15,
    label: "resources.campaigns.title",
    name: "campaigns",
    icon: <MarketerIcon />
  }
];
const marketerItemsRecruiter = [
  {
    id: 19,
    label: "resources.list",
    name: "marketers",
    icon: <MarketerIcon />
  },
  {
    id: 15,
    label: "resources.campaigns.title",
    name: "campaigns",
    icon: <MarketerIcon />
  }
];
const indosatItems = [
  {
    id: 24,
    label: "resources.sim.title",
    name: "sim",
    icon: <SimIcon />
  },
  {
    id: 25,
    label: "resources.activation.title",
    name: "activations",
    icon: <ActivationIcon />
  }
];

const paymentItems = [
  {
    id: 21,
    label: "resources.products.titleField.payments",
    name: "payment",
    icon: <PaymentIcon />
  },
  {
    id: 22,
    label: "resources.paymentmode.title",
    name: "paymentmode",
    icon: <PaymentIcon />
  }
];

const corporateCampaignItems = [
  {
    id: 27,
    label: "resources.corporate_campaign.title_submenu",
    name: "corporate_campaign",
    icon: <ProductIcon />
  }
];

function wrapState(ComposedComponent) {
  return class SelectableList extends Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
      defaultValue: PropTypes.number.isRequired
    };

    componentWillMount() {
      this.setState({
        selectedIndex: this.props.defaultValue
      });
    }

    handleRequestChange = (event, index) => {
      this.setState({
        selectedIndex: index
      });
    };

    render() {
      return (
        <ComposedComponent
          value={this.state.selectedIndex}
          onChange={this.handleRequestChange}
          selectedItemStyle={{ color: "#00bcd4" }}
        >
          {this.props.children}
        </ComposedComponent>
      );
    }
  };
}

SelectableList = wrapState(SelectableList);

const MenuSelectable = ({ onMenuTap, translate, logout }) => (
  <div style={styles.main}>
    <SelectableList defaultValue={1}>
      <WithPermission value="Admin">
        <ListItem
          value={1}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.orders.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={orderItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={4}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.products.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={productItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={8}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.customers.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={customerItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={11}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.contents.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={contentItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`${item.link}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={13}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.accounts.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={accountItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />

        <ListItem
          value={18}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.marketers.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={marketerItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
            />
          ))}
        />
        {/* <ListItem
          value={18}
          style={styles.menuItemStyle}
          key="reloads"
          containerElement={<Link to="/reloads" />}
          primaryText={translate(`resources.reloads.title`)}
          rightIcon={<EditorIcon />}
        /> */}
      </WithPermission>
      <WithPermission value="Recruiter">
        <ListItem
          value={18}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.marketers.title`)}
          primaryTogglesNestedList={true}
          initiallyOpen={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={marketerItemsRecruiter.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
            />
          ))}
        />
      </WithPermission>
      <WithPermission value="Partner Admin">
        <ListItem
          value={1}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.orders.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={orderItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={4}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.products.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={merchantProductItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
      </WithPermission>
      <WithPermission value="Partner User">
        <ListItem
          value={1}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.orders.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={orderItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={4}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.products.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={merchantProductItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
      </WithPermission>

      <WithPermission value="Admin">
        <ListItem
          value={23}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.sim.titleIndosat`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={indosatItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={222}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.payments.title`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={paymentItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
        <ListItem
          value={223}
          style={styles.menuItemSubHeaderStyle}
          primaryText={translate(`resources.corporate_campaign.title_menu`)}
          primaryTogglesNestedList={true}
          nestedListStyle={styles.menuSubStyle}
          nestedItems={corporateCampaignItems.map(item => (
            <ListItem
              value={item.id}
              style={styles.menuItemStyle}
              key={item.name}
              containerElement={<Link to={`/${item.name}`} />}
              primaryText={translate(`${item.label}`)}
              rightIcon={item.icon}
              onClick={onMenuTap}
            />
          ))}
        />
      </WithPermission>
      {logout}
    </SelectableList>
  </div>
);

const enhance = compose(
  connect(state => ({
    theme: state.theme,
    locale: state.locale
  })),
  translate
);

export default enhance(MenuSelectable);



// WEBPACK FOOTER //
// ./src/menu/index.js